/**
 * Extract document metadata from an annotation.
 */
export function documentMetadata(annotation) {
  var uri = annotation.uri;
  var domain;
  try {
    domain = new URL(uri).hostname;
  } catch (_unused) {
    // Annotation URI parsing on the backend is very liberal compared to the URL
    // constructor. There is also some historic invalid data in h (eg [1]).
    // Hence, we must handle URL parsing failures in the client.
    //
    // [1] https://github.com/hypothesis/client/issues/3666
    domain = '';
  }
  if (domain === 'localhost') {
    domain = '';
  }
  var title = domain;
  if (annotation.document && annotation.document.title) {
    title = annotation.document.title[0];
  }
  return {
    uri: uri,
    domain: domain,
    title: title
  };
}
/**
 * Return the domain and title of an annotation for display on an annotation
 * card.
 */
export function domainAndTitle(annotation) {
  return {
    domain: domainTextFromAnnotation(annotation),
    titleText: titleTextFromAnnotation(annotation),
    titleLink: titleLinkFromAnnotation(annotation)
  };
}
function titleLinkFromAnnotation(annotation) {
  var titleLink = annotation.uri;
  if (titleLink && !(titleLink.indexOf('http://') === 0 || titleLink.indexOf('https://') === 0)) {
    // We only link to http(s) URLs.
    titleLink = null;
  }
  if (annotation.links && annotation.links.incontext) {
    titleLink = annotation.links.incontext;
  }
  return titleLink;
}
/**
 * Returns the domain text from an annotation.
 */
function domainTextFromAnnotation(annotation) {
  var document = documentMetadata(annotation);
  var domainText = '';
  if (document.uri && document.uri.indexOf('file://') === 0 && document.title) {
    var parts = document.uri.split('/');
    var filename = parts[parts.length - 1];
    if (filename) {
      domainText = filename;
    }
  } else if (document.domain && document.domain !== document.title) {
    domainText = document.domain;
  }
  return domainText;
}

/**
 * Returns the title text from an annotation and crops it to 30 chars
 * if needed.
 */
function titleTextFromAnnotation(annotation) {
  var document = documentMetadata(annotation);
  var titleText = document.title;
  if (titleText.length > 30) {
    titleText = titleText.slice(0, 30) + '…';
  }
  return titleText;
}
//# sourceMappingURL=annotation-metadata.js.map